import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronExpand';
/** Renders an SVG icon. */
const SvgChevronExpand = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.204 13.796c.44.439 1.152.439 1.591 0L16 8.59l5.204 5.205a1.125 1.125 0 0 0 1.591-1.591l-6-6a1.125 1.125 0 0 0-1.59 0l-6 6a1.123 1.123 0 0 0 0 1.59Zm0 4.408a1.126 1.126 0 0 1 1.591 0L16 23.41l5.204-5.204a1.125 1.125 0 0 1 1.591 1.59l-6 6c-.439.44-1.151.44-1.59 0l-6-6a1.125 1.125 0 0 1 0-1.59Z"
      />
    </svg>
  );
};
SvgChevronExpand.displayName = displayName;
export default SvgChevronExpand;
